export default __webpack_public_path__ + "static/media/banner1.16ef7281.jpg";